// components/Home/Home.js
import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <header className="vought-header">
        <h1>VOUGHT<span>INTERNATIONAL</span></h1>
      </header>

      <main className="hero-section">
        <h2 className="tagline">JUSTICE. LIBERTY. PROFIT.</h2>
        <button className="join-button">BECOME A HERO</button>
      </main>

      <section className="the-boys-overlay">
        <p>F**K THE SUPES</p>
      </section>
    </div>
  );
};

export default Home;